import { render } from "./EtatProduitRupture.vue?vue&type=template&id=27ce446c&ts=true"
import script from "./EtatProduitRupture.vue?vue&type=script&lang=ts"
export * from "./EtatProduitRupture.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__